import React from 'react';
import Button from './Buttons';

interface TabProps {
  label: string;
  value: string;
  children: React.ReactNode;
}

interface TabsProps {
  children: React.ReactElement<TabProps> | React.ReactElement<TabProps>[];
  activeTab: string;
  onTabChange: (value: string) => void;
}

export function Tabs({ children, activeTab, onTabChange }: TabsProps) {
  return (
    <div>
      <div className="tabs mb-5">
        {React.Children.map(children, (child) => {
          if (!React.isValidElement<TabProps>(child)) return null;
          return (
            <Button
              variant={child.props.value === activeTab ? 'primary' : 'secondary'}
              size="large"
              onClick={() => onTabChange(child.props.value)}
            >
              {child.props.label}
            </Button>
          );
        })}
      </div>
      <div className="tab-content d-flex w-100">
        {React.Children.map(children, (child) => {
          if (!React.isValidElement<TabProps>(child)) return null;
          return child.props.value === activeTab ? child : null;
        })}
      </div>
    </div>
  );
}

export function Tab({ children }: TabProps) {
  return <div className="d-flex wrap-text w-100">{children}</div>;
}
